export class JobCreateForm {
  public jobNumber: string;
  public customer: string;
  public creationDate: string;
  public contractStartDate: string;
  public contractEndDate: string;
  public quotation: string;
  public contractSum: string;
  public remarks: string;
  public equipmentIds: Array<string>;

  constructor(
    jobNumber = '',
    customer = '',
    CreationDate = '',
    contractStartDate = '',
    contractEndDate = '',
    quotation = '',
    contractSum = '',
    remarks = '',
    equipmentIds = null
  ) { }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/jobCreateForm.ts